import React, { useEffect, useState } from "react";

import "./Leaderboard.css";
import "@mui/material";
import { useBackground } from "../context/BackgroundContext";
import {
  Autocomplete,
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Select,
  InputAdornment,
} from "@mui/material";
import { Search } from "@mui/icons-material";
import Api from "../utils/Api";
import { useNavigate } from "react-router-dom";
import Loading from "../composant/Loading/LoadingComponent";

/**
 * Classe Leaderboard qui permet d'afficher le classement des utilisateurs
 */
export default function Leaderboard() {
  const { backgroundUrl } = useBackground();
  const [leaderboard, setLeaderboard] = useState([]);
  const [sessions, _] = useState([]);
  const [session, setSession] = useState(1);
  const [search, setSearch] = useState("");
  const navigate = useNavigate();
  const [loaded, setLoaded] = useState(false);

  /**
   * fonction qui permet d'aller chercher les données du classement à la session n°1 par défaut quand on ouvre la page
   */
  useEffect(() => {
    // Api.get('/stats/leaderboard/' + this.state.sessions[3].dateDebut + '/' + this.state.sessions[3].dateFin)
    Api.get("/stats/leaderboard")
      .then((response) => {
        const valeursLeaderboard = response.data;

        for (let i = 0; i < valeursLeaderboard.length; i++) {
          valeursLeaderboard[i].position = i + 1;
        }
        setLoaded(true);
        setLeaderboard(valeursLeaderboard);
        console.log(valeursLeaderboard);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  /**
   * fonction qui permet de mettre à jour la valeur du search
   * @param {*} event
   */
  function handleChange(event) {
    const valeur = event.target.value;
    setSearch(valeur);
  }

  /**
   *  fonction qui permet de filtrer le classement par le nom de l'utilisateur
   * @returns le classement filtré par le nom de l'utilisateur
   */
  function filterLeaderboard() {
    return leaderboard.filter((item) => {
      return item.username.toLowerCase().includes(search.toLowerCase());
    });
  }

  /**
   * fonction dirigeant l'utilisateur vers la page de l'utilisateur qu'il veut visité
   * @param {*} id l'id de l'utilisateur à visité
   */
  function visitUser(id) {
    navigate(`/utilisateur/${id}`);
  }

  /*
   * Autocomplétion trié en ordre alphabétiquepour rechercher un utilisateur dans le classement
   *
   * @author: Félix Dupras-Simard [felixdupras@gmail.com]
   * Inspiré de MUI - [Modèle massif de langage] - https://mui.com/material-ui/react-autocomplete/#combo-box - [Consulté le 9 avril 2026]
   * Inspiré de StackOverflow - https://stackoverflow.com/questions/73582640/groupby-autocomplete-sorting-of-options-in-material-ui#73582994
   */
  function AutocompletionRechercheTri() {
    const options = [...leaderboard]
      .sort((a, b) =>
        a.username.toLowerCase() > b.username.toLowerCase() ? 1 : -1,
      )
      .map((user) => `${user.username}`);
    return (
      <Box
        sx={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          mb: 2,
        }}
      >
        <Autocomplete
          id="rechercheLeaderboard"
          freeSolo
          options={options}
          sx={{ width: 300 }}
          inputValue={search}
          onInputChange={(event, newInputValue) => setSearch(newInputValue)}
          renderInput={(params) => (
            <TextField {...params} label="Rechercher un utilisateur" />
          )}
        />
      </Box>
    );
  }

  return (
    <div className="leaderboard" style={{ backgroundImage: backgroundUrl ? `url(${backgroundUrl})` : 'none' }}>
      {!loaded?<Loading></Loading>:<hr></hr>}
      <div className="leaderboard-container">
        <div className="leaderboard-background">
          <div className="leaderboard-title">
            <h1>Classement</h1>
          </div>
          <div className="leaderboard-table">
            <div className="leaderboard-table-header">
              {AutocompletionRechercheTri()}
            </div>
            <TableContainer
              sx={{
                border: 1,
                borderColor: "#c4c4c4",
                borderStyle: "solid",
                borderRadius: 1,
                maxHeight: "calc(100vh - 350px)",
                width: "98%",
              }}
            >
              <Table stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell>Position</TableCell>
                    <TableCell>Nom</TableCell>
                    <TableCell>Score</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {filterLeaderboard().map((item, index) => (
                    <TableRow
                      key={item.id}
                      onClick={() => visitUser(item.id)}
                      className="colone"
                    >
                      <TableCell>{item.position}</TableCell>
                      <TableCell>{item.username}</TableCell>
                      <TableCell>{item.badges_count}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        </div>
      </div>
    </div>
  );
}
